import { useTranslation } from "react-i18next";
import { type FilterWithOption } from "~/hooks/useFilter";
import { ActiveFilterChips, type ActiveFilterChip } from "./ActiveFilterChips";

interface Props<T> {
  /** The `activeFilters` of a useFilter model. */
  activeFilters: FilterWithOption<T>[];
  onSelectFilter: (filterId: string, optionIds: string[]) => void;
}

export function SelectActiveFilterChips<T>({
  activeFilters,
  onSelectFilter,
}: Props<T>) {
  const { t } = useTranslation();

  const items: ActiveFilterChip[] = activeFilters.map((filter) => {
    const selected = new Set(filter.optionIds);

    return {
      key: filter.id,
      label: filter.label,
      comparatorLabel: t(($) => $.library.filters.includes),
      value: filter.options
        .filter((option) => selected.has(option.value))
        .map((option) => option.label)
        .join(", "),
      onRemove: () => onSelectFilter(filter.id, []),
    };
  });

  return <ActiveFilterChips items={items} />;
}
